<template>
  <v-card class="border areas-form-shell">
    <div class="areas-form-shell__hero">
      <div class="areas-form-shell__hero-bg" />
      <v-card class="areas-form-shell__header" flat>
        <div class="areas-form-shell__header-main">
          <div v-if="!isDisplaySmall" class="areas-form-shell__icon-wrap">
            <v-icon class="areas-form-shell__icon" color="white">{{ icon }}</v-icon>
          </div>
          <div class="areas-form-shell__titles">
            <h2 :class="['areas-form-shell__title', { 'areas-form-shell__title--small': isDisplaySmall }]">
              {{ title }}
            </h2>
            <p v-if="subtitle" class="areas-form-shell__subtitle mb-0">{{ subtitle }}</p>
          </div>
        </div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              text
              class="areas-form-shell__close"
              @click="$emit('close')"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Закрыть</span>
        </v-tooltip>
      </v-card>
    </div>

    <v-card-text class="areas-form-shell__body">
      <div class="areas-form-shell__content">
        <slot />
        <div v-if="showActions" class="areas-form-shell__actions">
          <v-btn
            outlined
            rounded
            class="text-none areas-form-shell__btn areas-form-shell__btn--cancel"
            @click="$emit('close')"
          >
            Отмена
          </v-btn>
          <v-btn
            rounded
            dark
            class="text-none areas-form-shell__btn areas-form-shell__btn--save"
            :loading="saving"
            @click="$emit('save')"
          >
            <v-icon left small>{{ isCreate ? 'mdi-plus-circle-outline' : 'mdi-content-save-outline' }}</v-icon>
            {{ saveLabel }}
          </v-btn>
        </div>
      </div>
    </v-card-text>

    <v-card-actions v-if="$slots.footer" class="areas-form-shell__footer-wrap pa-0">
      <div class="areas-form-shell__footer">
        <slot name="footer" />
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'AreasFormDialogShell',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'mdi-map-marker',
    },
    saving: {
      type: Boolean,
      default: false,
    },
    saveLabel: {
      type: String,
      default: 'Сохранить',
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      isDisplaySmall: false,
    };
  },
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkSize);
  },
  methods: {
    checkSize () {
      this.isDisplaySmall = window.innerWidth <= 800;
    },
  },
};
</script>

<style lang="scss" scoped>
.areas-form-shell {
  overflow: hidden;
  background: #fff;
}

.areas-form-shell__hero {
  position: relative;
}

.areas-form-shell__hero-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #4c6c93 0%, #5d7fa8 55%, #6b8cb5 100%);
}

.areas-form-shell__header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 20px 22px;
  background: transparent !important;
}

.areas-form-shell__header-main {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
}

.areas-form-shell__icon-wrap {
  flex: 0 0 auto;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(4px);
}

.areas-form-shell__icon {
  font-size: 28px !important;
}

.areas-form-shell__titles {
  min-width: 0;
  padding-top: 2px;
}

.areas-form-shell__title {
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1.25;
  color: #fff;
  margin: 0;
  letter-spacing: -0.01em;
}

.areas-form-shell__title--small {
  font-size: 1.125rem;
}

.areas-form-shell__subtitle {
  margin-top: 6px;
  font-size: 0.875rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.88);
  max-width: 520px;
}

.areas-form-shell__close {
  flex: 0 0 auto;
  margin-top: -4px;
}

.areas-form-shell__body {
  padding: 20px 24px 8px !important;
}

.areas-form-shell__content {
  max-width: 640px;
  margin: 0 auto;
}

.areas-form-shell__actions {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 8px;
}

.areas-form-shell__btn {
  min-width: 148px;
  font-weight: 500;
  letter-spacing: 0;
}

.areas-form-shell__btn--save {
  background: linear-gradient(135deg, #4c6c93, #5d7fa8) !important;
  box-shadow: 0 4px 12px rgba(76, 108, 147, 0.28);
}

.areas-form-shell__btn--cancel {
  border-color: #c5d0dc !important;
  color: #546e7a !important;
}

.areas-form-shell__footer-wrap {
  display: block;
}

.areas-form-shell__footer {
  padding: 14px 24px 18px;
  background: #f4f7fa;
  border-top: 1px solid #e3eaf0;
}

.border {
  border-radius: 16px;
}

@media screen and (max-width: 800px) {
  .areas-form-shell__body {
    padding: 16px 14px 8px !important;
  }

  .areas-form-shell__header {
    padding: 16px 14px 18px;
  }

  .areas-form-shell__footer {
    padding: 12px 14px 16px;
  }
}
</style>
